// 文件
import file from './file.js';
// 图片-服务
export default {
  /**
   * 获取本地图片地址，可以用img标签加载
   *
   * @param file 图片文件
   */
  path(file) {
    var path = null;
    if (window.createObjectURL != undefined) {
      // basic
      path = window.createObjectURL(file);
    } else if (window.URL != undefined) {
      // mozilla(firefox)
      path = window.URL.createObjectURL(file);
    } else if (window.webkitURL != undefined) {
      // webkit or chrome
      path = window.webkitURL.createObjectURL(file);
    }
    return path;
  },

  /**
   * 选择图片
   *
   * @param count 数量
   */
  choose(count = 1) {
    return file.choose('image', count);
  },

  /**
   * 预览图片
   */
  preview() {

  },

  pickThemeColor(url) {
    return new Promise((resolve, reject) => {
      let rgba = 'rgba(255,255,255,1)'
      let oImg = new Image();
      oImg.onload = function () {
        const w = '100';
        const h = '100';
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const context = canvas.getContext('2d');
        context.drawImage(this, 0, 0);
        try {
          let pxArr = context.getImageData(0, 0, w, h).data;
          pxArr = Array.from(pxArr);
          const colorList = {}
          let i = 0;
          while (i < pxArr.length) {
            const r = pxArr[i];
            const g = pxArr[i + 1];
            const b = pxArr[i + 2];
            const a = pxArr[i + 3];
            i = i + 4;
            const key = [r, g, b, a].join(',')
            key in colorList ? ++colorList[key] : (colorList[key] = 1)
          }
          let arr = [];
          for (let key in colorList) {
            arr.push({
              rgba: `rgba(${key})`,
              num: colorList[key]
            })
          }
          arr = arr.sort((a, b) => b.num - a.num)
          rgba = arr[0].rgba
          resolve(rgba);
        } catch (e) {
          reject(rgba);
        }
      }
      oImg.src = url
      oImg.setAttribute('crossOrigin', '')
    })

  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/image.js